import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { GameService } from 'src/app/services/game/game.service';
import { MessageOptionsService } from 'src/app/services/message/message-options.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-modal-help',
  templateUrl: './modal-help.component.html',
  styleUrls: ['./modal-help.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalHelpComponent implements OnInit {
  panelOpenState = false;
  accion = 0;
  id = undefined;
  dataUser: any;
  token = "";
  consulta = "";
  motivo = "";

  paso = 1;
  espera = false;
  esperaFinal = false;

  @Output() saveButton = new EventEmitter<Object>();

  constructor(
    private gameService: GameService,
    private userService: UsuarioService,
    private messageOptions: MessageOptionsService
  ) { }

  ngOnInit(): void {
    this.id = parseInt(localStorage.getItem('idgame'));
    let data = this.userService.getLocalStorage();
    this.dataUser = data['user'];
    this.token = data['token'];
  }

  emailHelp() {
    let body = {
      "titulo": this.motivo,
      "mensaje": this.consulta
    };
    this.gameService.emailHelp(this.token, body).subscribe(res => {
      if (res['status'] === 'success') {
        this.paso++;
        this.espera = true;
      } else {
      }
    }, error => { this.messageOptions.enviar(error) });

  }




  continuePaso(acciones) {
    this.accion = acciones;
    this.paso++;
    this.espera = true;
  }


  validate() {
    this.paso++;
    this.espera = true;



  }
  back() {
    this.paso--;
    this.accion = 0;
    this.espera = false
  }

  finalized() {
    this.saveButton.emit({
      type: "finalized",
      value: this.accion
    })
  }

  close() {
    this.saveButton.emit({
      type: "close",
      value: ""
    })
  }

}
